import React, { useEffect, useState } from 'react';
import { Card } from './card.component';
import upSolidIcon from '../assets/img/header-chevron-up-solid.svg';
import downSolidIcon from '../assets/img/header-chevron-up-solid.svg';
import { DatePicker, Loader } from 'rsuite';
import { Button } from './button.component';
import { GetInvoiceReport } from '../core/apis/reporting';
import { InvoiceReportResponse } from '../models/api';
import { StorageAuth } from '../core/localStorage';
import { UtilityDate } from '../utils/dateUtils';

function InvoiceReportComponent() {
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [isBusy, setIsBusy] = useState(false);
  const [reportData, setReportData] = useState<InvoiceReportResponse>();

  const isValidStartDate = (date?: Date) => {
    if (!date) return false;
    if (!endDate) return true;
    if (date <= endDate) return true;
    return false;
  };

  const isValidEndDate = (date?: Date) => {
    if (!date) return false;
    if (!startDate) return true;
    if (date >= startDate) return true;
    return false;
  };

  const fetchReport = () => {
    setIsBusy(true);
    let startDateWithTime: Date | undefined;
    let endDateWithTime: Date | undefined;
    if (startDate) {
      startDateWithTime = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
      );
    }
    if (endDate) {
      endDateWithTime = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate(),
        23,
        59,
        59
      );
    }
    GetInvoiceReport({
      fromDate: startDateWithTime?.toISOString(),
      toDate: endDateWithTime?.toISOString(),
      companyId: StorageAuth.CompanyId!,
    }).then((res) => {
      setIsBusy(false);
      if (res.data.data) {
        setReportData(res.data.data);
      }
    });
  };

  useEffect(() => {
    const startOfMonth = UtilityDate.getStartOfPreviousMonth();
    const endOfMonth = UtilityDate.getEndOfPreviousMonth();
    setIsBusy(true);
    GetInvoiceReport({
      fromDate: startOfMonth.toISOString(),
      toDate: endOfMonth.toISOString(),
      companyId: StorageAuth.CompanyId!,
    }).then((res) => {
      setIsBusy(false);
      if (res.data.data) {
        setReportData(res.data.data);
      }
    });
    setStartDate(startOfMonth);
    setEndDate(endOfMonth);
  }, []);

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Invoice Report
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <a
            className="btn  box-collapse-btn me-1"
            data-bs-toggle="collapse"
            href="#invoice_report"
            role="button"
            aria-expanded="false"
            aria-controls="missing_invoice"
          >
            <img
              src={upSolidIcon}
              alt="up"
              className="img-fluid svg-btn collapse-close"
            />
            <img
              src={downSolidIcon}
              alt="down"
              className="img-fluid svg-btn collapse-open"
            />
          </a>
        </div>
      }
      className='h-100'
    >
      <div id="invoice_report" className="container pt-1 pb-5">
        <div className="row g-0 align-items-center">
          <div className="col-auto">
            <span className="pe-1">Start Date</span>
          </div>
          <div className="col-3">
            <DatePicker
              disabledDate={(date?: Date) => !isValidStartDate(date)}
              onChange={setStartDate}
              value={startDate}
              format="MM-dd-yyyy"
            />
          </div>

          <div className="col-auto ps-2">
            <span className="pe-1">End Date</span>
          </div>

          <div className="col-3">
            <DatePicker
              disabledDate={(date?: Date) => !isValidEndDate(date)}
              onChange={setEndDate}
              value={endDate}
              format="MM-dd-yyyy"
            />
          </div>
          <div className="col-auto ps-2">
            <Button name="Search" className="btn-green" onClick={fetchReport} />
          </div>
        </div>
        <div className="row g-0 align-items-center pt-3">
          <div className="col-12">
            {isBusy && (
              <div className="text-center">
                <Loader size="sm" className="text-center" />
              </div>
            )}
            {!isBusy && !!reportData && (
              <div>
                <div>
                  <span>Paid: </span>
                  <span>{reportData?.paidCount}</span>
                </div>

                <div>
                  <span>Due: </span>
                  <span>{reportData?.dueCount}</span>
                </div>

                <div>
                  <span>Ready to send: </span>
                  <span>{reportData?.readyToSendToFinance}</span>
                </div>

                <div>
                  <span>Waiting for patient/caregiver signature: </span>
                  <span>{reportData?.missingCaregiverSignatureCount}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="py-5" />
        <div className="py-5" />
      </div>
    </Card>
  );
}

export const InvoiceReport = React.memo(InvoiceReportComponent);
